import { render } from "./ColorSwatchPicker.vue?vue&type=template&id=53ecd30d&scoped=true"
import script from "./ColorSwatchPicker.vue?vue&type=script&lang=js"
export * from "./ColorSwatchPicker.vue?vue&type=script&lang=js"

import "./ColorSwatchPicker.vue?vue&type=style&index=0&id=53ecd30d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ecd30d"]])

export default __exports__